import React from 'react'
import PropTypes from 'prop-types'

import ChartsContainer from './charts/ChartsContainer'

import { withRouter } from 'react-router-dom'
import useStore from '../../hooks/useStore'

function TimelineContainer({ match }) {
  const activeYear = (match.params.year && Number(match.params.year)) || 1940
  const { state } = useStore()
  const { lang, activeChart } = state

  return (
    <ChartsContainer
      lang={lang}
      activeChart={activeChart}
      activeYear={activeYear}
    />
  )
}

TimelineContainer.propTypes = {
  match: PropTypes.object
}

export default withRouter(TimelineContainer)
